import React from 'react'
import { makeStyles } from '@material-ui/core'
import ArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { tableVirtualizedStyles } from './styles'
import cl from 'classnames'

const useStyles = makeStyles(theme => ({
    ...tableVirtualizedStyles(theme),
    root: {
        display: 'flex'
    },
    cellRoot: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        color: theme.textSecondary,
        fontWeight: 'bold'
    },
    cellContent: {
        display: 'flex',
        alignItems: 'center'
    },
    cellContentSortable: {
        cursor: 'pointer',
        '&:hover': {
            color: `${theme.textPrimary} !important`
        }
    }
}))

function TableVirtualizedHeader(props) {
    const classes = useStyles()

    const { style, columns, columnIndexToWidth, sortBy, onHeaderColumnClick } = props

    return (
        <div style={style} className={cl(classes.root, classes.rowRootCommon)}>
            {columns.map((column, columnIndex) => {
                const columnKey = column.key
                const isFirstColumn = !columnIndex
                return (
                    <div
                        style={{ width: columnIndexToWidth[columnIndex] }}
                        key={`header-cell-${columnKey}`}
                        className={cl({
                            [classes.cellRoot]: true,
                            [classes.cellRootCommon]: true,
                            [classes.firstCellRootCommon]: isFirstColumn,
                            [classes.cellAlignCenter]: column.alignCenter
                        })}
                        headercellcolumnkey={columnKey}
                        columnkey={columnKey}
                    >
                        <span
                            className={cl({
                                [classes.cellInnerCommon]: true,
                                [classes.cellContent]: true,
                                [classes.cellContentSortable]: column.sortable
                            })}
                            onClick={() => onHeaderColumnClick(column)}
                        >
                            {column.label}
                            {column.sortable &&
                                sortBy &&
                                sortBy.key === columnKey &&
                                (sortBy.desc ? <ArrowDownIcon /> : <ArrowUpIcon />)}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

export { TableVirtualizedHeader }
